import { createContext, useContext } from "react";
import type { Language, Translations } from "./types";
import en from "./translations/en";
import es from "./translations/es";
import fr from "./translations/fr";
import de from "./translations/de";
import it from "./translations/it";
import pt from "./translations/pt";
import tr from "./translations/tr";

export { LANGUAGES } from "./types";
export type { Language, Translations } from "./types";

const translationsMap: Record<Language, Translations> = {
  en,
  es,
  fr,
  de,
  it,
  pt,
  tr,
};

export function getTranslations(lang: Language): Translations {
  return translationsMap[lang] || en;
}

export function isValidLanguage(code: string): code is Language {
  return code in translationsMap;
}

export type LanguageContextValue = {
  language: Language;
  translations: Translations;
  setLanguage: (lang: Language) => void;
  /** Returns the path with the language prefix (or without for English) */
  localizedPath: (path: string) => string;
};

export const LanguageContext = createContext<LanguageContextValue>({
  language: "en",
  translations: en,
  setLanguage: () => {},
  localizedPath: (path: string) => path,
});

export function useTranslation(): LanguageContextValue {
  return useContext(LanguageContext);
}
